import { render, staticRenderFns } from "./BuildProgress.vue?vue&type=template&id=2196a8bb&scoped=true&"
import script from "./BuildProgress.vue?vue&type=script&lang=js&"
export * from "./BuildProgress.vue?vue&type=script&lang=js&"
import style0 from "./BuildProgress.vue?vue&type=style&index=0&id=2196a8bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196a8bb",
  null
  
)

export default component.exports